(function() {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('CustomGroupTypeAttribute', CustomGroupTypeAttribute);

    CustomGroupTypeAttribute.$inject = ['$resource'];

    function CustomGroupTypeAttribute ($resource) {
        var resourceUrl =  'api/custom-group-type-attributes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
